/**
 * Configurazione dipendente dall'ambiente, letta a runtime da `window.__ENV__`.
 * L'oggetto è popolato da `/config.js`, caricato in `index.html` prima del
 * bundle: in Docker lo genera l'entrypoint dal template `public/config.tpl.js`,
 * in locale lo genera `vue.config.js` dal `.env`. Così la stessa build serve
 * qualsiasi ambiente.
 *
 * Le variabili non impostate arrivano come stringa vuota (envsubst), quindi i
 * fallback usano `||` e non `??`.
 */
type RuntimeEnv = {
  PARSE_SERVER_URL?: string;
  API_BASE_URL?: string;
  VIEW_MENU_BASE_URL?: string;
  SENTRY_DSN?: string;
  SENTRY_ENVIRONMENT?: string;
};

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

const env: RuntimeEnv = window.__ENV__ || {};

export const config = {
  parseServerUrl: env.PARSE_SERVER_URL || "http://127.0.0.1:1337/parse",
  apiBaseUrl: env.API_BASE_URL || "",
  viewMenuBaseUrl: env.VIEW_MENU_BASE_URL || "",
  // Vuoto = Sentry non viene installato.
  sentryDsn: env.SENTRY_DSN || "",
  sentryEnvironment: env.SENTRY_ENVIRONMENT || "",
};
